<template>
  <section class="clients">
    <div class="container">
      <div class="header">
        <h2 class="titulo">{{ $t('homePage.clientes') }}</h2>
      </div>

      <div class="clients-carousel">
        <div
          v-for="(client, index) in loopClientImages"
          :key="`${client.alt}-${index}`"
          class="client-card"
          :class="{ loaded: loadedSrcs[client.src] }"
        >
          <div class="client-spinner" aria-hidden="true"></div>
          <a
            v-if="client.link"
            :href="client.link"
            target="_blank"
            rel="noopener noreferrer"
            class="client-link"
          >
            <img
              :src="client.src"
              :alt="client.alt"
              class="client-image"
              draggable="false"
              @load="loadedSrcs[client.src] = true"
            />
          </a>
          <img
            v-else
            :src="client.src"
            :alt="client.alt"
            class="client-image"
            draggable="false"
            @load="loadedSrcs[client.src] = true"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, reactive, onMounted } from 'vue'

import fallbackNetflix from '@/assets/clientes/Netflix.png'
import fallback1 from '@/assets/clientes/RedBull.png'
import fallback2 from '@/assets/clientes/Einhell.png'
import fallback3 from '@/assets/clientes/Dorflex.png'
import fallback4 from '@/assets/clientes/Kanit.png'
import fallback5 from '@/assets/clientes/Havan.png'
import fallback6 from '@/assets/clientes/Desktop.png'
import fallback7 from '@/assets/clientes/Resso.png'
import fallback8 from '@/assets/clientes/Banggood.png'

const FALLBACK = [
  { src: fallbackNetflix, alt: 'Netflix',  link: '' },
  { src: fallback1,       alt: 'RedBull',  link: '' },
  { src: fallback2,       alt: 'Einhell',  link: '' },
  { src: fallback3,       alt: 'Dorflex',  link: '' },
  { src: fallback4,       alt: 'Kanit',    link: '' },
  { src: fallback5,       alt: 'Havan',    link: '' },
  { src: fallback6,       alt: 'Desktop',  link: '' },
  { src: fallback7,       alt: 'Resso',    link: '' },
  { src: fallback8,       alt: 'Banggood', link: '' },
]

const clientImages = ref(FALLBACK)
const loadedSrcs = reactive({})

const loopClientImages = computed(() => [...clientImages.value, ...clientImages.value])

onMounted(async () => {
  const apiUrl = process.env.VUE_APP_API_URL
  if (!apiUrl) return

  try {
    const res  = await fetch(`${apiUrl}/api/content`)
    const data = await res.json()
    if (Array.isArray(data.sponsors) && data.sponsors.length > 0) {
      clientImages.value = data.sponsors.map(s => ({
        src:  `${apiUrl}${s.imageUrl}`,
        alt:  s.name,
        link: s.link || '',
      }))
    }
  } catch {
    // mantém o fallback com as imagens embutidas
  }
})
</script>

<style scoped>
.clients {
  min-height: 0;
  background: var(--color-light);
  color: var(--color-bg-dark);
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 24px;
  text-align: left;
}

.header {
  display: block;
  margin-bottom: 16px;
}

.titulo {
  margin: 0;
  font-family: "Bebas Neue", sans-serif;
  font-size: 50px;
  font-weight: 400;
}

.clients-carousel {
  display: flex;
  gap: 30px;
  width: max-content;
  animation: scroll-right 50s linear infinite;
}

.client-card {
  flex: 0 0 180px;
  aspect-ratio: 1 / 1;
  border-radius: 12px;
  overflow: hidden;
  border: 0;
  position: relative;
  background: #e8e8e8;
}

.client-spinner {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.client-spinner::after {
  content: '';
  width: 32px;
  height: 32px;
  border: 3px solid rgba(0, 0, 0, 0.12);
  border-top-color: #1e2a3a;
  border-radius: 50%;
  animation: client-spin 0.7s linear infinite;
}

.client-card.loaded .client-spinner {
  display: none;
}

.client-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.client-card.loaded .client-image {
  opacity: 1;
}

@keyframes client-spin {
  to { transform: rotate(360deg); }
}

.client-link {
  display: block;
  width: 100%;
  height: 100%;
}

.container {
  overflow: hidden;
}

@keyframes scroll-right {
  from { transform: translateX(0%); }
  to   { transform: translateX(-50%); }
}

@media (aspect-ratio <= 3/4) {
  .client-card {
    flex-basis: 150px;
  }
}
</style>
